export default {
  "membership.validPeriod": "有効期間",
  "membership.automaticUpdate": "自動更新",
  "membership.membershipFeePaymenMethod": "会費の決済方法",
  "membership.window-renewal-fee": "窓口更新料金",
  "membership.internet-update-fee": "ネット更新料金",
  "membership.create.title": "会員制度 追加",
  "membership.edit.title": "会員制度 編集",
  "membership.detail.form.plsEnter": "入力してください",
  "membership.detail.form.bePoints": "全国共通券（その他全国共通券含む）にポイント付与",
  "membership.detail.form.canbeused": "会員期限切れてもクーポンが使える",
  "membership.detail.form.updateSetting": "入会・更新設定",
  "membership.detail.form.paymentMethods": "会費の決済方法",
  "membership.detail.form.admissionFee(Yan)": "入会費（円）",
  "membership.detail.form.additionAdmissionFee(Yan)": "窓口入会追加費用（円）",
  "membership.detail.form.additionOnlineAdmissionFee(Yan)": "ネット入会追加費用（円）",
  "membership.detail.form.renewalFee(Yan)": "更新料（円）",
  "membership.detail.form.addtionalWindowRenewalFee(Yan)": "窓口更新追加費用（円）",
  "membership.detail.form.internetUpdateAdditionalCost(Yan)": "ネット更新追加費用（円）",
  "membership.detail.form.updateBonus": "更新特典",
  "membership.detail.form.ageGroup.default": "デフォルト",
  "membership.detail.form.ageGroup.defaultNote": "年齢区分に該当しない場合、誕生日が未登録の場合、該当区分の費用が未設定の場合はこの費用で請求されます。",
  "membership.detail.form.ageGroup.changeWelfare": "切替特典",
  "membership.detail.form.ageGroup.add": "年齢区分を追加",
  "membership.detail.form.ageGroup.select": "追加する年齢区分を選択",
  "membership.detail.form.ageGroup.addConfirm": "追加",
  "membership.detail.form.ageGroup.noMore": "追加できる年齢区分がありません",
  "membership.detail.form.ageGroup.regrant": "切替特典を補発",
  "membership.detail.form.ageGroup.regrantDisabled.unsaved": "保存後に補発できます",
  "membership.detail.form.ageGroup.regrantDisabled.noWelfare": "切替特典が保存されていません",
  "membership.detail.form.ageGroup.regrantDisabled.lowest": "0歳から始まる年齢区分は切替特典の対象外です",
  "membership.detail.form.ageGroup.overlapSuffix": " ※追加済みの区分と年齢が重複",
  "membership.detail.form.ageGroup.loadFailed": "年齢区分の取得に失敗しました。年齢区分ごとの費用は今回編集できません（保存済みの設定はそのまま保持されます）。",
  "memberAgeGroup.title": "年齢区分",
  "memberAgeGroup.name": "区分名",
  "memberAgeGroup.minAge": "年齢（下限）",
  "memberAgeGroup.maxAge": "年齢（上限）",
  "memberAgeGroup.maxAge.hint": "空欄＝上限なし",
  "memberAgeGroup.sort": "表示順",
  "memberAgeGroup.ageRange": "年齢範囲",
  "memberAgeGroup.create": "年齢区分を追加",
  "memberAgeGroup.edit": "年齢区分を編集",
  "memberAgeGroup.note": "入会日・更新日（JST）の年齢で区分を判定します。区分同士の年齢範囲は重複できますが、同じ会員制度の中では重複できません。",
  "memberAgeGroup.changeWelfare.title": "切替特典の手動補発",
  "memberAgeGroup.changeWelfare.days": "過去日数",
  "memberAgeGroup.changeWelfare.target": "補発対象",
  "memberAgeGroup.changeWelfare.note": "保存済みの切替特典を、指定した過去日数の間にこの年齢区分へ切り替わった会員に付与します。付与済みの会員には再付与しません。",
  "memberAgeGroup.changeWelfare.submit": "補発する",
  "memberAgeGroup.changeWelfare.daysError": max => `過去日数は1〜${max}日の範囲で入力してください。`,
  "membership.detail.form.couponsToDistribute": "配布するクーポン",
  "membership.detail.form.givePoints": "付与するポイント数",
  "membership.detail.form.points": "ポイント数",
  "membership.detail.form.offSetPoints": "調整後ポイント残高",
  "membership.detail.form.givePoints.placeholder": "例）1000",
  "membership.detail.form.rank-setting": "ランク設定",
  "membership.detail.form.rank-order": "ランク順番",
  "membership.detail.form.add": "ランク追加",
  "membership.detail.form.remove": "ランク削除",
  "membership.detail.form.rankPrivilege": "ランク特典",
  "membership.detail.form.point-setting": "ポイント付与設定",
  "membership.detail.form.point-earn": "一回鑑賞（上映会）での獲得ポイント",
  "membership.detail.form.point-visitor": "入場人数（チケット）/1回での獲得ポイント",
  "membership.detail.form.point-amount": "100円ごと獲得ポイント（チケット）　※切り捨て",
  "membership.detail.form.point-amount.concession": "100円ごと獲得ポイント（コンセ）　※切り捨て",
  "membership.detail.form.point-amount.conmercial": "100円ごと獲得ポイント（物販）　※切り捨て",
  "membership.detail.form.point-amount.placeholder": "例）1000",
  "membership.detail.form.point-earn.tips": "※一回鑑賞すると、〇〇ptを付与",
  "membership.detail.form.point-visitor.tips": "※一回ごとで○○人と鑑賞すると、1人ごとで〇〇ptを付与",
  "membership.detail.form.point-amount.tips": "※取引の消費金額に応じて、100円ごとに◯◯ptを付与",
  "membership.detail.form.rankUp-setting": "ランクアップ設定",
  "membership.detail.form.rankDown-setting": "ランクダウン設定",
  "membership.detail.form.upgrade-condition": "アップグレード条件",
  "membership.detail.form.downgrade-condition": "ダウングレード条件",
  "membership.detail.form.condition": "条件",
  "membership.detail.form.displayMessage": "表示メッセージ",
  "membership.detail.form.message": "メッセージ",
  "membership.detail.form.rankExplanation": "ランク説明",
  "membership.detail.form.terms": "会員規約",
  "membership.detail.form.introduction": "会員制度紹介",
  "membership.detail.form.plsInputValidPeriod": "有効期間を入力してください",
  "membership.detail.form.plsInputAdmissionFee(Yan)": "入会費（円）を入力してください",
  "membership.detail.form.plsInputAdditionAdmissionFee(Yan)": "窓口入会追加費用（円）を入力してください",
  "membership.detail.form.plsInputAdditionOnlineAdmissionFee(Yan)": "ネット入会追加費用（円）を入力してください",
  "membership.detail.form.plsInputRenewalFee(Yan)": "更新料（円）を入力してください",
  "membership.detail.form.plsInputAddtionalWindowRenewalFee(Yan)": "窓口更新追加費用（円）を入力してください",
  "membership.detail.form.plsInputInternetUpdateAdditionalCost(Yan)": "ネット更新追加費用（円）を入力してください",
  "membership.detail.form.plsInputPoint-Earn": "一回鑑賞（上映会）での獲得ポイントを入力してください",
  "membership.detail.form.plsInputPoint-Visitor": "入場人数（チケット）/1回での獲得ポイントを入力してください",
  "membership.detail.form.plsInputTerms": "会員規約を入力してください",
  "membership.coupon.title": "会員クーポン一覧",
  "membership.coupon.memberID": "会員ID",
  "membership.coupon.memberType": "会員種類",
  "membership.coupon.rank": "ランク",
  "membership.coupon.consumption": "累計消費額",
  "membership.coupon.enrollmentDate": "入会日付",
  "membership.memberList.searchPlaceholder": "会員ID、名前、メールアドレス、電話番号などで検索",
  "membership.memberList.status": "状態",
  "membership.memberList.dialog.title": "会員詳細",
  "membership.memberList.dialog.basic": "会員基本情報",
  "membership.memberList.dialog.stopUsing": "利用停止",
  "membership.memberList.dialog.reopen": "利用再開",
  // Key kept for compatibility; label renamed per human.answer-1 (MemberStatus.delete is 退会)
  "membership.memberList.dialog.deleteAccount": "退会",
  "membership.memberList.dialog.quit": "解約",
  "membership.memberList.dialog.enrollmentDate": "加入日付",
  "membership.memberList.dialog.favoriteGenre": "好きなジャンル",
  "membership.memberList.dialog.amount": "累計消費金額",
  "membership.memberList.memberPoint": "会員の累計ポイント",
  "membership.memberList.totalPoint": "所有ポイント",
  "membership.memberList.dialog.favTheater": "お気に入り映画館",
  "membership.memberList.dialog.information": "会員種類情報",
  "membership.memberList.dialog.information.change": "会員種類変更",
  "membership.memberList.dialog.information.rank-change": "ランク変更",
  "membership.memberList.dialog.information.rankUpNumber-change": "ランクアップまでの回数変更",
  "membership.memberList.dialog.information.cancel": "解約",
  "membership.memberList.dialog.personal.title": "個人情報",
  "membership.memberList.dialog.personal.edit": "個人情報編集",
  "membership.memberList.dialog.personal.furigana": "フリガナ",
  "membership.memberList.dialog.personal.gender": "性别",
  "membership.memberList.dialog.personal.birthday": "生年月日",
  "membership.memberList.dialog.personal.telNumber": "電話番号",
  "membership.memberList.dialog.personal.email": "メールアドレス",
  "membership.memberList.dialog.personal.dialog.chineseLastName": "漢字(姓)",
  "membership.memberList.dialog.personal.dialog.chineseFirstName": "漢字(名)",
  "membership.memberList.dialog.personal.dialog.lastName": "フリガナ(姓)",
  "membership.memberList.dialog.personal.dialog.firstName": "フリガナ(名)",
  "membership.memberList.dialog.personal.dialog.birthday": "生年月日",
  "membership.memberList.dialog.personal.dialog.postalCode": "郵便番号（半角）",
  "membership.memberList.dialog.personal.dialog.streetAddress": "番地・建物名・部屋番号など",
  "membership.memberList.dialog.history.title": "履歴",
  "membership.memberList.dialog.history.ticket-history": "優待券利用履歴",
  "membership.memberList.dialog.history.ticket": "チケット購入履歴",
  "membership.memberList.dialog.history.shop": "売店購入履歴",
  "membership.memberList.dialog.history.point": "ポイント",
  "membership.memberList.dialog.history.sales-history": "コンセ販売履歴",
  "membership.memberList.dialog.history.merchandise-sales-history": "物販販売履歴",
  "membership.memberList.dialog.history.rank-history": "ランク履歴",
  "membership.memberList.dialog.history.change-history": "会員種類変更履歴",
  "membership.memberList.dialog.history.couponID": "クーポンID",
  "membership.memberList.dialog.history.couponTypeId": "クーポン種類ID",
  "membership.memberList.dialog.history.couponName": "券名",
  "membership.memberList.dialog.history.getDate": "獲得日時",
  "membership.memberList.dialog.history.useTheater": "利用劇場",
  "membership.memberList.dialog.history.ticket-grant": "優待券付与",
  "membership.memberList.dialog.history.table.useDate": "利用日時",
  "membership.memberList.dialog.history.table.usePlace": "利用場所",
  "membership.memberList.dialog.history.dialog.selectCoupon": "付与する優待券を選択してください",
  "membership.memberList.dialog.history.shop.createTransactionTime": "購入日時",
  "membership.memberList.dialog.history.shop.productName": "品名",
  "membership.memberList.dialog.history.shop.unitPrice": "税込単価",
  "membership.memberList.dialog.history.shop.taxRate": "税率",
  "membership.memberList.dialog.history.shop.qty": "数量",
  "membership.memberList.dialog.history.shop.total": "税込価格",
  "membership.memberList.viewNumbers": "鑑賞回数",
  "membership.memberList.upgradesLeft": "ランクアップまでの回数",
  "memberShip.occurDate": "発生日時",
  "memberShip.log.memberShip": "会員制度",
  "memberShip.log.updateTime": "更新した有効期限",
  "memberShip.log.expiredTime": "有効期限",
  "memberShip.log.count": "残り利用可能回数",
  "memberShip.log.useCount": "利用した回数",

  "couponList.sideMenu": "クーポン一覧",
  "couponList.title": "会員クーポン一覧",
  "couponList.targetMemberShip": "対象会員制度",
  "couponList.targetMemberRank": "対象ランク",
  "couponList.numberPoints": "引換ポイント数",
  "couponList.exchangeNumber": "引換可能回数",
  "couponList.exchangeTime": "引換可能期間あり",
  "couponList.distribution": "配布",
  "couponList.dialog.title": "会員クーポン　作成/編集",
  "couponList.dialog.memberShipType": "適用会員種類",
  "couponList.dialog.memberShipRank": "適用ランク",
  "couponList.dialog.exchangeType": "引換可能期間種類",
  "couponList.dialog.exchangeCondition": "引換条件",
  "couponList.dialog.detailMsg": "詳細情報",
  "couponList.dialog.useCondition": "利用条件",
  "couponList.dialog.plsInputCount": "利用可能回数を入力してください",
  "couponList.limited": "制限あり",
  "couponList.memberShipType.plsInput": "適用会員種類を入力してください",
  "couponList.memberShipRank.plsInput": "適用ランクを入力してください",
  "couponList.clCouponCode": "クーポン・割引券ID（旧CINEMA LOYALTYから移行用）",
  "couponList.sendCoupon": "配布",
  "couponList.distribution": "配布対象",
  "couponList.distribution.ageGroup": "年齢層",
  "couponList.distribution.gender": "性別",
  "couponList.distribution.joinStartTime": "入会時期",
  "couponList.distribution.sendTime": "配布時間",


  "endUserCustomizePage.sideMenu": "会員サイトカスタマイズ",
  "endUserCusomizePage.displayName": "表示名",
  "endUserCusomizePage.transferOldName": "旧会員からの移行",
  "endUserCusomizePage.isShowNumber": "会員カード番号連携",
  "endUserCusomizePage.colorStyle": "カラースタイル",
  "endUserCusomizePage.themeColor": "テーマの色",
  "endUserCusomizePage.favicon": "ファビコン",
  "endUserCusomizePage.metaData": "メタデータ",

  "auto.point": "配布ポイント数",
  "auto.coupon": "配布優待券",
  "auto.edit": "自動ルール　作成/編集",
  "auto.action": "アクション",
  "auto.message.title": "配布するメッセージ（タイトル）",
  "auto.message.content": "配布するメッセージ（内容）",
  "auto.stop": "停止",
  "auto.ageGroup.none": "年齢区分なし（全年齢が対象）",
  "auto.ageGroup.notInMemberShip": " ※会員制度で未使用",
  "auto.ageGroup.deleted": "削除済みの年齢区分",
  "auto.status.active": "正常",
  "auto.status.inactive": "停止中",
};